import React from 'react'
import {Typography} from "@mui/material"

const Feedback = () => {
    return(
        <Typography variant="h3">The Feedback Page</Typography>
    )
}

export default Feedback;